import ladenRob from "../../images/gallerij/Laden Rob.avif"
import ervaring from "../../images/gallerij/20211005_154935.avif"
import gespecialiseerd from "../../images/gallerij/20211005_155750.avif"
import hero from "../../images/gallerij/Hoofdfoto.avif"
import css from "./homepage.module.scss"
import InfoCard from "../../components/info-card/info-card";
import Badge from "../../components/badges/badges";
import Seo from "../../components/seo/Seo";
import Reveal from "../../components/animations/Reveal";
import {
    faBox,
    faClipboardCheck,
    faDroplet, faFileExport,
    faListCheck,
    faShippingFast,
    faStar, faWarehouse
} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";

const Homepage = () => {
    return (
        <div className={css.container}>
            <Seo
                title="BolleNoord 't Zand B.V. | Dé specialist in bollenopslag en verwerking"
                description="Professionele verwerking, opslag en exportvoorbereiding van bloembollen in 't Zand (Noord-Holland). Betrouwbaar, efficiënt en deskundig – met meer dan 40 bewaarcellen en aandacht voor kwaliteit."
                path="/"
            />
            <Reveal variant="fade-up">
                <img src={hero} alt={"Het kantoor en werkplek van BolleNoord"}  className={css.hero}/>
            </Reveal>

            <Reveal variant="fade-up">
                <div className={css.intro}>
                    <h2>Waarom BolleNoord?</h2>

                    <div className={css.cards}>
                        <Reveal variant="fade-up"><InfoCard
                            image={ladenRob}
                            alt={"het inladen van kuubs met bloembollen waarbij er een gesprek gevoerd wordt over de werkzaamheden"}
                            title={"Meedenkend"}
                            description={"Bij BolleNoord kunt u terecht voor het spoelen, " +
                                "opslaan, keuren en het inpakken van bloembollen. Ook regelen wij de administratie hier omheen. " +
                                "En zelfs al verlenen wij momenteel de door u gewenste dienst nog niet dan kunt u altijd " +
                                "contact met ons opnemen zodat wij kunnen bekijken wat we voor u kunnen betekenen."}
                            /></Reveal>
                        <Reveal variant="fade-up" delayMs={100}><InfoCard
                            image={ervaring}
                            alt={"bollen die gecontroleerd worden op een lopende band door een specialist"}
                            title={"Ervaring"}
                            description={"Behalve alle apparatuur en computers die wij tot onze beschikking hebben om de " +
                                "optimale bewaring te realiseren, " +
                                "zorgen wij er ook altijd voor dat elke dag fysieke controle wordt gedaan in de cel. " +
                                "Zo kunnen wij garanderen dat er altijd goed voor uw product gezorgd wordt. "}
                        /></Reveal>
                        <Reveal variant="fade-up" delayMs={200}><InfoCard
                            image={gespecialiseerd}
                            alt={"temp"}
                            title={"Gespecialiseerd"}
                            description={"Wij zijn gespecialiseerd in het geven van temperatuurbehandelingen aan bloembollen," +
                                " knollen en vaste planten. Wij kunnen diverse temperatuursbehandelingen aanbieden van -3 tot " +
                                "+30 graden. Hiernaast kunnen wij ook ULO, Ozon en droogkoelbewaring aanbieden. Neem voor " +
                                "advies contact met ons op. Contact"}
                        /></Reveal>
                    </div>
                </div>
            </Reveal>

            <Reveal variant="fade-up">
                <div className={css.closing}>
                    <h1>Dé professional in bollenopslag – Betrouwbaar, efficiënt en deskundig</h1>
                    <p>
                        Met jarenlange ervaring en gespecialiseerde faciliteiten bieden wij een professionele oplossing voor de opslag van bloembollen.
                        Efficiëntie, kwaliteit en zorg staan bij ons centraal.
                    </p>
                    <p>
                        Met meer dan 40 cellen beschikken wij over de perfecte omstandigheden voor elk product, waarbij we de juiste temperatuur en luchtvochtigheid kunnen garanderen. Dit stelt ons in staat om een breed assortiment aan bloembollen, vaste planten en diverse gewassen op te slaan - van tulpen, lelies en amaryllis tot narcissen, gladiolen, irissen en vele andere soorten.
                    </p>
                    <p>
                        Heeft u vragen of wilt u meer weten over de mogelijkheden? Ga dan naar onze <Link to={"/contact"}>contactpagina</Link> – we helpen u graag verder.
                    </p>
                </div>
            </Reveal>

            <div className={css.services}>
                <Reveal variant="fade-up"><h2>Onze Werkzaamheden</h2></Reveal>

                <Reveal variant="fade-up">
                    <div className={css.badges}>
                        <Badge icon={faDroplet} title="Spoelen" />
                        <Badge icon={faBox} title="Inpakken" />
                        <Badge icon={faStar} title="Kwaliteitscontrole" />
                        <Badge icon={faClipboardCheck} title="Export en importkeuringen" />
                        <Badge icon={faListCheck} title="Orderpicking" />
                        <Badge icon={faShippingFast} title="Containers laden" />
                        <Badge icon={faFileExport} title="vracht en export papieren" />
                        <Badge icon={faWarehouse} title="Voorraadbeheer" />
                    </div>
                </Reveal>
            </div>
        </div>
    )
}

export default Homepage